// extracted by mini-css-extract-plugin
module.exports = {"sideBarHeader":"sidebar-tabs_sideBarHeader__23wU3","sportBtn":"sidebar-tabs_sportBtn__jvDcW","active":"sidebar-tabs_active__lYIfd","liveBtn":"sidebar-tabs_liveBtn__zITVR"};